import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';

import {
  changeDatesPage,
  changeDatesPageSuccess,
  createDate,
  createDateError,
  createDateSuccess,
  deleteDate,
  deleteDateError,
  deleteDateSuccess,
  loadBlockedDates,
  loadBlockedDatesSuccess,
  refreshDates,
} from '../actions/campaigns.action';
import { CampaignService } from '../services/campaign.service';
import { Store } from '@ngrx/store';
import { IReducers } from '../reducers';

@Injectable()
export class DatesEffect {
  loadBlockedDates$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadBlockedDates),
      switchMap(({ pagination }) => this.campaignsService.getDates(pagination)),
      map(res => {
        return loadBlockedDatesSuccess({ ...res });
      }),
    ),
  );

  refreshDates = createEffect(() =>
    this.actions$.pipe(
      ofType(refreshDates),
      switchMap(action =>
        of(
          loadBlockedDates({
            pagination: null,
          }),
        ),
      ),
    ),
  );

  deleteDate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteDate),
      switchMap(action =>
        this.campaignsService.deleteDate(action.dates).pipe(
          map(res =>
            deleteDateSuccess({
              response: res,
            }),
          ),
          catchError(err =>
            of(
              deleteDateError({
                error: err,
              }),
            ),
          ),
        ),
      ),
    ),
  );

  changeDatesPage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(changeDatesPage),
      mergeMap(action => {
        return this.campaignsService
          .getBlockedDates({
            current_page: action.page,
            page_size: action.page_size,
          })
          .pipe(
            map(res => {
              return res;
            }),
          );
      }),
      map(res => {
        return changeDatesPageSuccess({
          items: res.items,
          pagination: {
            current_page: res.current_page,
            page_size: res.current_page,
            has_more_data: res.has_more_data,
            total_pages_count: res.total_page_count,
            total_count: res.total_count,
          },
        });
      }),
    ),
  );

  createDate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createDate),
      switchMap(action =>
        this.campaignsService
          .createDate(action.dates, action.accountId, action.isManager)
          .pipe(
            tap(() =>
              this.store$.dispatch(
                loadBlockedDates({
                  pagination: {
                    current_page: 1,
                    page_size: 10,
                  },
                }),
              ),
            ),
            map(res => createDateSuccess({ response: res })),
            catchError(error => of(createDateError({ error }))),
          ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private campaignsService: CampaignService,
    private readonly store$: Store<IReducers>,
  ) {
  }
}
